import {get, post, put, _delete} from './Tools';

const getAll = async () => {
  const response = await get(`${process.env.REACT_APP_SERVER}saldo_empleado`);
  return response;
};

const getList = async () => {
  const response = await get(`${process.env.REACT_APP_SERVER}saldo_empleado/get/list`);
  return response;
};

const getById = async (id) => {
  const response = await get(`${process.env.REACT_APP_SERVER}saldo_empleado/${id}`);
  return response;
};

const getByEmpleadoId = async (empleado_id) => {
  const response = await get(`${process.env.REACT_APP_SERVER}saldo_empleado/get/empleado/${empleado_id}`);
  return response;
};



const insert = async (payload) => {
  const response = await post(`${process.env.REACT_APP_SERVER}saldo_empleado`, payload);
  return response;
};

const update = async (payload) => {
  const response = await put(`${process.env.REACT_APP_SERVER}saldo_empleado`, payload);
  return response;
};

const drop = async (id) => {
  const response = await _delete(`${process.env.REACT_APP_SERVER}saldo_empleado/${id}`);
  return response;
};

// Importación masiva
const importBulk = async (file, force_save = false) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('force_save', force_save ? 1 : 0);

  const response = await fetch(`${process.env.REACT_APP_SERVER}saldo_empleado/import`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
    body: formData,
  });

  return await response.json();
};

const importBulkConfirm = async (cached_records) => {
  const payload = {
    cached_records,
  };
  const response = await post(`${process.env.REACT_APP_SERVER}saldo_empleado/import/confirm`, payload);
  return response;
};

export { getAll, getList, getById, getByEmpleadoId, insert, update, drop, importBulk, importBulkConfirm };
